// extracted by mini-css-extract-plugin
export default {"container":"GK-z","darkBackground":"HK-z","whiteBackground":"IK-z","headerButton":"JK-z","calloutHeading":"KK-z","calloutSubHeading":"LK-z"};